/** URL to choose a plan and extend an existing slot subscription. */
export function buildSlotExtensionPayUrl({
  slot,
  codification,
  subscriptionPath,
  promoCode,
  currentExpiringDate,
}) {
  const params = new URLSearchParams();
  params.set("slot", String(slot));
  if (codification) params.set("reserve", codification);
  if (subscriptionPath) params.set("path", subscriptionPath);
  if (promoCode) params.set("promo", promoCode);
  if (currentExpiringDate) {
    params.set("currentExp", String(currentExpiringDate).slice(0, 10));
  }
  return `/ExtendSlot?${params.toString()}`;
}
